export const CyDeleteCrewDialog = {
  ConfirmButton: "DeleteCrewDialogConfirmButton",
} as const;
